import { FrontWeightDesignMode } from '@/lib/piano/touch-design/design/front-weight-design';
import { StrikeWeightRatioDesignMode } from '@/lib/piano/touch-design/design/strike-weight-ratio-design';
import { StrikeWeightDesignMode } from '@/lib/piano/touch-design/design/strike-weight-design';
import { WippenSupportSpringsDesignMode } from '@/lib/piano/touch-design/design/wippen-support-springs-design';
import type { FullBackupData } from '@/lib/backup/measure-backup';
export const gaveauModele1: FullBackupData = {
  design: {
    frontWeightDesignComputedBalanceWeightTarget: 39,
    frontWeightDesignMode: FrontWeightDesignMode.Computed,
    frontWeightDesignStandardTarget: 7,
    frontWeightDesignTarget: 39,
    strikeWeightDesignComputedBalanceWeightTarget: 38,
    strikeWeightDesignLatestSmoothTarget: 'lsr',
    strikeWeightDesignLatestStandarTarget: 'SW#5',
    strikeWeightDesignMode: StrikeWeightDesignMode.StandardCurves,
    strikeWeightDesignTarget: 'SW#5',
    strikeWeightRatioDesignLatestFixedTarget: 6,
    strikeWeightRatioDesignLatestSmoothTarget: 'median',
    strikeWeightRatioDesignMode: StrikeWeightRatioDesignMode.FixedValue,
    strikeWeightRatioDesignTarget: 6,
    wippenSupportSpringsDesignLatestNumberOfSprings: 48,
    wippenSupportSpringsDesignLatestSpringBalanceWeight: 9.5,
    wippenSupportSpringsDesignLatestTensionDropIndex: 1,
    wippenSupportSpringsDesignMode: WippenSupportSpringsDesignMode.SmoothTransition,
    wippenSupportSpringsDesignTarget: {
      numberOfSprings: 48,
      springBalanceWeight: 9.5,
      tensionDropIndex: 1
    }
  },
  measureOptions: {
    useManualSWRMeasurements: false,
    useSupportSpringMeasurements: false
  },
  measures: {
    keyWeightRatio: 0.5,
    keys: [{
      downWeightWithSpringSupport: 70,
      downWeightWithoutSpringSupport: 82,
      frontWeight: 7.06,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 10.25,
      upWeight: 51,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 72,
      downWeightWithoutSpringSupport: 87,
      frontWeight: 5.68,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 10.3,
      upWeight: 57,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 69,
      downWeightWithoutSpringSupport: 80,
      frontWeight: 3.77,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.98,
      upWeight: 54,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 75,
      downWeightWithoutSpringSupport: 85,
      frontWeight: 3.78,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 10.2,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 66,
      downWeightWithoutSpringSupport: 79,
      frontWeight: 5.1,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 10.2,
      upWeight: 56,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 63,
      downWeightWithoutSpringSupport: 78,
      frontWeight: 5,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 10.1,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 70,
      downWeightWithoutSpringSupport: 84,
      frontWeight: 4.65,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 10,
      upWeight: 55,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 68,
      downWeightWithoutSpringSupport: 81,
      frontWeight: 3.39,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.92,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 65,
      downWeightWithoutSpringSupport: 79,
      frontWeight: 5.28,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.86,
      upWeight: 55,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 71,
      downWeightWithoutSpringSupport: 88,
      frontWeight: 4.07,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.95,
      upWeight: 61,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 66,
      downWeightWithoutSpringSupport: 80,
      frontWeight: 3.45,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.9,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 65,
      downWeightWithoutSpringSupport: 83,
      frontWeight: 5.32,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.8,
      upWeight: 57,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 62,
      downWeightWithoutSpringSupport: 77,
      frontWeight: 3.76,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.6,
      upWeight: 52,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 67,
      downWeightWithoutSpringSupport: 84,
      frontWeight: 3.8,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.6,
      upWeight: 58,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 61,
      downWeightWithoutSpringSupport: 75,
      frontWeight: 3.75,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.6,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 60,
      downWeightWithoutSpringSupport: 77,
      frontWeight: 4.15,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.91,
      upWeight: 56,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 63,
      downWeightWithoutSpringSupport: 80,
      frontWeight: 2.37,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.68,
      upWeight: 57,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 64,
      downWeightWithoutSpringSupport: 79,
      frontWeight: 3.77,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.82,
      upWeight: 56,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 64,
      downWeightWithoutSpringSupport: 79,
      frontWeight: 4.21,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.67,
      upWeight: 56,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 68,
      downWeightWithoutSpringSupport: 81,
      frontWeight: 4.6,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.83,
      upWeight: 56,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 64,
      downWeightWithoutSpringSupport: 80,
      frontWeight: 1.88,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.78,
      upWeight: 57,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 66,
      downWeightWithoutSpringSupport: 84,
      frontWeight: 2.6,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.51,
      upWeight: 56,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 61,
      downWeightWithoutSpringSupport: 80,
      frontWeight: 1.79,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.6,
      upWeight: 57,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 61,
      downWeightWithoutSpringSupport: 79,
      frontWeight: 5.36,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.5,
      upWeight: 55,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 55,
      downWeightWithoutSpringSupport: 75,
      frontWeight: 4.18,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.4,
      upWeight: 50,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 61,
      downWeightWithoutSpringSupport: 80,
      frontWeight: 2.78,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.28,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 62,
      downWeightWithoutSpringSupport: 79,
      frontWeight: 2.04,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.37,
      upWeight: 55,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 57,
      downWeightWithoutSpringSupport: 74,
      frontWeight: 3.01,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 9.17,
      upWeight: 51,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 58,
      downWeightWithoutSpringSupport: 71,
      frontWeight: 4.57,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.44,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 52,
      downWeightWithoutSpringSupport: 67,
      frontWeight: 4.56,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.33,
      upWeight: 46,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 52,
      downWeightWithoutSpringSupport: 66,
      frontWeight: 7.47,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.11,
      upWeight: 44,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 53,
      downWeightWithoutSpringSupport: 67,
      frontWeight: 3.85,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.47,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 58,
      downWeightWithoutSpringSupport: 71,
      frontWeight: 1.4,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.32,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 59,
      downWeightWithoutSpringSupport: 74,
      frontWeight: 3.85,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.78,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 52,
      downWeightWithoutSpringSupport: 66,
      frontWeight: 2.84,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.6,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 54,
      downWeightWithoutSpringSupport: 68,
      frontWeight: 3.98,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.63,
      upWeight: 51,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 52,
      downWeightWithoutSpringSupport: 65,
      frontWeight: 2.3,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.51,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 54,
      downWeightWithoutSpringSupport: 70,
      frontWeight: 2.94,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.54,
      upWeight: 51,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 58,
      downWeightWithoutSpringSupport: 71,
      frontWeight: 2.03,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.71,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 52,
      downWeightWithoutSpringSupport: 67,
      frontWeight: 4.06,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.54,
      upWeight: 46,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 58,
      downWeightWithoutSpringSupport: 76,
      frontWeight: 4.45,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.42,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 55,
      downWeightWithoutSpringSupport: 71,
      frontWeight: 2.78,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.63,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 53,
      downWeightWithoutSpringSupport: 68,
      frontWeight: 4.8,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.54,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 52,
      downWeightWithoutSpringSupport: 66,
      frontWeight: 3.22,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.35,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 49,
      downWeightWithoutSpringSupport: 64,
      frontWeight: 4,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 8.34,
      upWeight: 43,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 50,
      downWeightWithoutSpringSupport: 65,
      frontWeight: 4.49,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.76,
      upWeight: 46,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 51,
      downWeightWithoutSpringSupport: 63,
      frontWeight: 2.92,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.7,
      upWeight: 44,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: 53,
      downWeightWithoutSpringSupport: 68,
      frontWeight: 0.4,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.66,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 60,
      frontWeight: 0.89,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.5,
      upWeight: 46,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: 4.57,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.48,
      upWeight: 45,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 59,
      frontWeight: 1.79,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.54,
      upWeight: 43,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 57,
      frontWeight: 2.4,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.17,
      upWeight: 42,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: 2.89,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.2,
      upWeight: 44,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 57,
      frontWeight: 2.85,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.34,
      upWeight: 43,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 58,
      frontWeight: 4.62,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.05,
      upWeight: 41,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 57,
      frontWeight: 2.5,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.09,
      upWeight: 41,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 56,
      frontWeight: 3.42,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 7.04,
      upWeight: 40,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 61,
      frontWeight: 3.12,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.87,
      upWeight: 43,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 57,
      frontWeight: 3.18,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.81,
      upWeight: 40,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: 3.48,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.74,
      upWeight: 41,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 55,
      frontWeight: 2.9,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.9,
      upWeight: 40,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 59,
      frontWeight: 2.54,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.84,
      upWeight: 42,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: 3.15,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.81,
      upWeight: 39,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 58,
      frontWeight: 3.45,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.8,
      upWeight: 38,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 56,
      frontWeight: 3.85,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.62,
      upWeight: 39,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 56,
      frontWeight: 4.34,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.73,
      upWeight: 38,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 60,
      frontWeight: 5.48,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.66,
      upWeight: 40,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 52,
      frontWeight: 4.49,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.52,
      upWeight: 36,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 64,
      frontWeight: -7.85,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.49,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 71,
      frontWeight: -8.6,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.38,
      upWeight: 53,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 64,
      frontWeight: -8.71,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.2,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 70,
      frontWeight: -8.42,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.4,
      upWeight: 50,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 66,
      frontWeight: -7.25,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.49,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 68,
      frontWeight: -8.4,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.32,
      upWeight: 51,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 65,
      frontWeight: -7.95,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.55,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 64,
      frontWeight: -7.47,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.18,
      upWeight: 48,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 66,
      frontWeight: -6.72,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.36,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 65,
      frontWeight: -7.66,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.27,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 64,
      frontWeight: -7.38,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.03,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 64,
      frontWeight: -7.21,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6,
      upWeight: 44,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: -8.32,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.84,
      upWeight: 44,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 63,
      frontWeight: -6.76,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 6.05,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: -8.24,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.9,
      upWeight: 45,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 65,
      frontWeight: -8.15,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.87,
      upWeight: 49,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 62,
      frontWeight: -8.53,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.6,
      upWeight: 42,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 64,
      frontWeight: -8.75,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.65,
      upWeight: 47,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 60,
      frontWeight: -8.89,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.67,
      upWeight: 44,
      wippenRadiusWeight: null
    }, {
      downWeightWithSpringSupport: null,
      downWeightWithoutSpringSupport: 50,
      frontWeight: -1.8,
      keyWeightRatio: null,
      measuredStrikeWeightRatio: null,
      strikeWeight: 5.41,
      upWeight: 37,
      wippenRadiusWeight: null
    }],
    wippenRadiusWeight: 19.5
  },
  piano: {
    brand: 'Gaveau',
    isDemoProfile: true,
    keyCount: 88,
    model: 'Modèle 1',
    serialNumber: '89XXX',
    startNote: {
      letter: 'A',
      octave: 0
    }
  }
};